import uniqBy from 'lodash/uniqBy';
import genererGuid from '@/services/general/genererGuid';

const LIBELLE_SANS_SECTEUR = 'Sans secteur d\'activité';

function formatData(data) {
  return {
    data,
    id: data.id,
    libelle: data.nomCommercial || data.libelle,
    children: [],
    selected: false,
    openSecteur: false,
  };
}

function compare(a, b) {
  if (a.libelle.toLowerCase() < b.libelle.toLowerCase()) {
    return -1;
  }
  if (a.libelle.toLowerCase() > b.libelle.toLowerCase()) {
    return 1;
  }
  return 0;
}

function getMarqueConcurrent(tiers) {
  const tiersMarque = tiers.tiersParent?.tiersMarques?.[0] || tiers.tiersMarques?.[0];
  return tiersMarque?.marque?.libelle || '';
}

export default function formatageConcurrents(pdvs, secteurActiviteId) {
  const data = [];
  const secteursActivitesEnseigne = pdvs
    .filter(p => p.tiersParent && p.tiersParent.secteurActivite)
    .map(p => p.tiersParent.secteurActivite);
  const secteursActivitesPdv = pdvs
    .filter(p => p.secteurActivite)
    .map(p => p.secteurActivite);
  const secteursActivites = uniqBy(secteursActivitesEnseigne.concat(secteursActivitesPdv), 'id');
  const pdvsFormat = pdvs.map(p => {
    const secteur = p.tiersParent?.secteurActivite?.id
      || p.secteurActivite?.id
      || p.secteurActiviteId
      || null;
    return {
      id: p.id,
      secteurActiviteId: secteur,
      marque: getMarqueConcurrent(p),
      libelle: p.nomCommercial,
      coordonnees: {
        lat: p.adressePostale?.latitude,
        lng: p.adressePostale?.longitude,
      },
      urlLogo: p.chemin,
    };
  });

  const pdvsWithSecteur = pdvsFormat.filter(p => p.secteurActiviteId);
  const pdvsWithoutSecteur = pdvsFormat.filter(p => !p.secteurActiviteId);

  secteursActivites.forEach(secteur => {
    const pdvsSecteur = pdvsWithSecteur.filter(p => p.secteurActiviteId === secteur.id);

    const marques = uniqBy(pdvsSecteur.filter(p => p.marque && p.marque !== '')
      .map(p => ({ libelle: p.marque.trim(), id: genererGuid() })), 'libelle')
      .map(formatData).sort(compare);
    marques.forEach(marque => {
      marque.children = pdvsSecteur
        .filter(p => p.marque && p.marque !== '' && p.marque.trim() === marque.libelle)
        .map(formatData)
        .sort(compare);
    });
    const pdvsWithoutMarque = pdvsSecteur.filter(p => !p.marque)
      .map(formatData)
      .map(p => ({ ...p, isPdv: true }))
      .sort(compare);

    data.push({
      ...formatData(secteur),
      children: [...marques, ...pdvsWithoutMarque],
    });
  });

  if (pdvsWithoutSecteur.length) {
    data.push({
      data: { id: 'sans-secteur', libelle: LIBELLE_SANS_SECTEUR },
      id: 'sans-secteur',
      libelle: LIBELLE_SANS_SECTEUR,
      selected: false,
      openSecteur: false,
      children: pdvsWithoutSecteur
        .map(formatData)
        .map(p => ({ ...p, isPdv: true }))
        .sort(compare),
    });
  }

  const dataSort = data.filter(el => el.children.length).sort(compare);
  if (secteurActiviteId) {
    const index = dataSort.findIndex(el => el.id === secteurActiviteId);
    if (index !== -1) {
      const currentSecteur = dataSort[index];
      currentSecteur.selected = true;
      currentSecteur.openSecteur = true;
      currentSecteur.children.forEach(el => {
        el.selected = true;
        el.children.forEach(c => {
          c.selected = true;
        });
      });
      dataSort.splice(index, 1);
      dataSort.unshift(currentSecteur);
    }
  }
  return dataSort;
}
